import React from 'react';
import { Switch } from 'antd';
import 'antd/dist/antd.css';

import styled from 'styled-components';

export interface ISwitcher {
  checked?: boolean;
  onClick?: (checked: boolean) => void;
  /** Только показать состояние: у роли нет права его менять. */
  disabled?: boolean;
}

export const Switcher = ({ checked, onClick, disabled }: ISwitcher) => (
  <SwitcherContainer>
    <Switch
      checked={checked}
      size="small"
      onClick={onClick}
      disabled={disabled}
    />
  </SwitcherContainer>
);

const SwitcherContainer = styled.div`
  .ant-switch-checked {
    background-color: #3cc13b;
  }
`;
